this.character = [
  {
    name: "遊龍チェン",
    rarity: 6,
    class: "狙撃",
    hp: 2501,
    atk: 773,
    def: 203,
    res: 0,
    block: 1,
    interval: 2.3,
    potential: [0, 33, 0, 0, 0],
    trust: [0, 80, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "12F",
    rarity: 2,
    class: "術師",
    hp: 1461,
    atk: 456,
    def: 50,
    res: 10,
    block: 1,
    interval: 2.9,
    potential: [0, 24, 0, 0, 0],
    trust: [0, 50, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "アーミヤ",
    rarity: 5,
    class: "術師",
    hp: 1480,
    atk: 612,
    def: 121,
    res: 20,
    block: 1,
    interval: 1.6,
    potential: [200, 30, 0, 0, 0],
    trust: [200, 70, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [150, 50, 0, 0, 0],
  },
  {
    name: "アーミヤ前衛",
    rarity: 5,
    class: "前衛",
    hp: 2629,
    atk: 657,
    def: 376,
    res: 20,
    block: 1,
    interval: 1.25,
    potential: [200, 28, 22, 0, 0],
    trust: [0, 45, 45, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "ブレイズ",
    rarity: 6,
    class: "前衛",
    hp: 2821,
    atk: 765,
    def: 370,
    res: 0,
    block: 3,
    interval: 1.2,
    potential: [0, 28, 0, 0, 0],
    trust: [0, 60, 45, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "チェン",
    rarity: 6,
    class: "前衛",
    hp: 2880,
    atk: 610,
    def: 352,
    res: 0,
    block: 2,
    interval: 1.3,
    potential: [0, 23, 0, 0, 0],
    trust: [0, 50, 50, 0, 0],
    moduleX: [0, 80, 0, 0, 7],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "ケルシー",
    rarity: 6,
    class: "医療",
    hp: 1633,
    atk: 490,
    def: 215,
    res: 0,
    block: 1,
    interval: 2.85,
    potential: [0, 25, 0, 0, 0],
    trust: [400, 0, 40, 0, 0],
    moduleX: [0, 60, 25, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "炎獄ラヴァ",
    rarity: 5,
    class: "術師",
    hp: 1543,
    atk: 798,
    def: 115,
    res: 20,
    block: 1,
    interval: 2.9,
    potential: [0, 0, 0, 0, 0],
    trust: [0, 90, 0, 0, 0],
    moduleX: [165, 62, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "ソラ",
    rarity: 5,
    class: "補助",
    hp: 1356,
    atk: 335,
    def: 238,
    res: 0,
    block: 1,
    interval: 1.0,
    potential: [140, 0, 0, 0, 0],
    trust: [0, 50, 20, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "濁心スカジ",
    rarity: 6,
    class: "補助",
    hp: 1603,
    atk: 368,
    def: 233,
    res: 0,
    block: 1,
    interval: 1.0,
    potential: [0, 27, 0, 0, 0],
    trust: [0, 50, 30, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "耀騎士ニアール",
    rarity: 6,
    class: "前衛",
    hp: 3550,
    atk: 1064,
    def: 295,
    res: 0,
    block: 1,
    interval: 1.5,
    potential: [0, 35, 0, 0, 0],
    trust: [200, 85, 0, 0, 0],
    moduleX: [330, 105, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "濯塵ハイビスカス",
    rarity: 5,
    class: "医療",
    hp: 1508,
    atk: 511,
    def: 109,
    res: 0,
    block: 1,
    interval: 1.6,
    potential: [0, 22, 0, 0, 0],
    trust: [0, 60, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "承曦グレイ",
    rarity: 5,
    class: "狙撃",
    hp: 1730,
    atk: 628,
    def: 240,
    res: 10,
    block: 1,
    interval: 2.1,
    potential: [0, 32, 0, 0, 0],
    trust: [150, 60, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "テキサス",
    rarity: 5,
    class: "先鋒",
    hp: 1950,
    atk: 500,
    def: 343,
    res: 0,
    block: 2,
    interval: 1.05,
    potential: [0, 24, 0, 0, 0],
    trust: [0, 70, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [155, 42, 22, 0, 0],
  },
  {
    name: "帰溟スペクター",
    rarity: 6,
    class: "特殊",
    hp: 2803,
    atk: 737,
    def: 322,
    res: 0,
    block: 2,
    interval: 1.2,
    potential: [0, 33, 0, 0, 0],
    trust: [0, 80, 0, 0, 0],
    moduleX: [250, 83, 30, 0, 0],
    moduleY: [250, 40, 55, 0, 0],
  },
  {
    name: "百錬ガヴィル",
    rarity: 6,
    class: "前衛",
    hp: 2906,
    atk: 766,
    def: 391,
    res: 0,
    block: 3,
    interval: 1.2,
    potential: [0, 28, 0, 0, 0],
    trust: [0, 60, 60, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "エクシア",
    rarity: 6,
    class: "狙撃",
    hp: 1673,
    atk: 540,
    def: 161,
    res: 0,
    block: 1,
    interval: 1.0,
    potential: [0, 27, 0, 0, 0],
    trust: [0, 90, 0, 0, 0],
    moduleX: [190, 41, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "フランカ",
    rarity: 5,
    class: "前衛",
    hp: 3768,
    atk: 936,
    def: 235,
    res: 0,
    block: 1,
    interval: 1.5,
    potential: [0, 30, 0, 0, 0],
    trust: [0, 75, 25, 0, 0],
    moduleX: [220, 95, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "リスカム",
    rarity: 5,
    class: "重装",
    hp: 3240,
    atk: 425,
    def: 710,
    res: 0,
    block: 3,
    interval: 1.2,
    potential: [0, 0, 28, 0, 0],
    trust: [0, 45, 45, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "サイレンス",
    rarity: 5,
    class: "医療",
    hp: 1595,
    atk: 482,
    def: 142,
    res: 0,
    block: 1,
    interval: 2.85,
    potential: [0, 24, 0, 0, 0],
    trust: [0, 75, 0, 0, 0],
    moduleX: [120, 0, 0, 0, 6],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "シージ",
    rarity: 6,
    class: "先鋒",
    hp: 2251,
    atk: 515,
    def: 384,
    res: 0,
    block: 2,
    interval: 1.05,
    potential: [0, 25, 0, 0, 0],
    trust: [0, 60, 25, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [260, 82, 0, 0, 0],
  },
  {
    name: "ディピカ",
    rarity: 4,
    class: "補助",
    hp: 1050,
    atk: 403,
    def: 125,
    res: 15,
    block: 1,
    interval: 1.6,
    potential: [0, 0, 0, 0, 8],
    trust: [300, 0, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [115, 35, 0, 0, 0],
  },
  {
    name: "ギターノ",
    rarity: 4,
    class: "術師",
    hp: 1598,
    atk: 715,
    def: 118,
    res: 20,
    block: 1,
    interval: 2.9,
    potential: [0, 27, 0, 0, 0],
    trust: [0, 70, 0, 0, 0],
    moduleX: [150, 57, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "フェン",
    rarity: 3,
    class: "先鋒",
    hp: 1325,
    atk: 325,
    def: 260,
    res: 0,
    block: 2,
    interval: 1.05,
    potential: [0, 0, 20, 0, 0],
    trust: [0, 0, 50, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "ビーグル",
    rarity: 3,
    class: "重装",
    hp: 2035,
    atk: 295,
    def: 490,
    res: 0,
    block: 3,
    interval: 1.2,
    potential: [0, 0, 28, 0, 0],
    trust: [0, 0, 60, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "クルース",
    rarity: 3,
    class: "狙撃",
    hp: 1060,
    atk: 375,
    def: 126,
    res: 0,
    block: 1,
    interval: 1.0,
    potential: [0, 21, 0, 0, 0],
    trust: [0, 50, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "寒芒クルース",
    rarity: 5,
    class: "狙撃",
    hp: 1520,
    atk: 502,
    def: 176,
    res: 0,
    block: 1,
    interval: 1.0,
    potential: [0, 0, 0, 0, 0],
    trust: [0, 75, 0, 0, 0],
    moduleX: [190, 31, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "ハイビスカス",
    rarity: 3,
    class: "医療",
    hp: 1220,
    atk: 345,
    def: 110,
    res: 0,
    block: 1,
    interval: 2.85,
    potential: [0, 18, 0, 0, 0],
    trust: [0, 45, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "W",
    rarity: 6,
    class: "狙撃",
    hp: 1605,
    atk: 912,
    def: 133,
    res: 0,
    block: 1,
    interval: 2.8,
    potential: [0, 35, 0, 0, 0],
    trust: [0, 100, 0, 0, 0],
    moduleX: [210, 78, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "シラユキ",
    rarity: 4,
    class: "狙撃",
    hp: 1630,
    atk: 797,
    def: 100,
    res: 0,
    block: 1,
    interval: 2.8,
    potential: [0, 30, 0, 0, 0],
    trust: [0, 70, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [160, 30, 0, 0, 5],
  },
  {
    name: "ラヴァ",
    rarity: 3,
    class: "術師",
    hp: 1141,
    atk: 582,
    def: 95,
    res: 0,
    block: 1,
    interval: 2.9,
    potential: [0, 0, 0, 0, 8],
    trust: [0, 60, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "ミルラ",
    rarity: 4,
    class: "医療",
    hp: 1420,
    atk: 465,
    def: 131,
    res: 0,
    block: 1,
    interval: 2.85,
    potential: [0, 0, 23, 0, 0],
    trust: [0, 60, 0, 0, 0],
    moduleX: [100, 0, 0, 0, 5],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "メテオ",
    rarity: 4,
    class: "狙撃",
    hp: 1370,
    atk: 465,
    def: 165,
    res: 0,
    block: 1,
    interval: 1.0,
    potential: [0, 23, 0, 0, 0],
    trust: [0, 65, 0, 0, 0],
    moduleX: [180, 30, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "ドーベルマン",
    rarity: 4,
    class: "前衛",
    hp: 2024,
    atk: 602,
    def: 382,
    res: 0,
    block: 2,
    interval: 1.05,
    potential: [150, 0, 0, 0, 0],
    trust: [0, 30, 30, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [80, 53, 0, 0, 5],
  },
  {
    name: "エステル",
    rarity: 4,
    class: "前衛",
    hp: 2500,
    atk: 690,
    def: 315,
    res: 0,
    block: 3,
    interval: 1.2,
    potential: [200, 0, 0, 0, 0],
    trust: [350, 0, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "フィリオプシス",
    rarity: 5,
    class: "医療",
    hp: 1610,
    atk: 335,
    def: 150,
    res: 0,
    block: 1,
    interval: 2.85,
    potential: [0, 21, 0, 0, 0],
    trust: [0, 55, 0, 0, 0],
    moduleX: [100, 47, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "アズリウス",
    rarity: 5,
    class: "狙撃",
    hp: 1230,
    atk: 535,
    def: 130,
    res: 0,
    block: 1,
    interval: 1.0,
    potential: [0, 24, 0, 0, 0],
    trust: [0, 75, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 30, 0, 0, 4],
  },
  {
    name: "エンカク",
    rarity: 5,
    class: "前衛",
    hp: 3907,
    atk: 918,
    def: 195,
    res: 0,
    block: 1,
    interval: 1.5,
    potential: [0, 0, 0, 0, 0],
    trust: [400, 45, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [430, 0, 0, 0, 5],
  },
  {
    name: "ホシグマ",
    rarity: 6,
    class: "重装",
    hp: 3850,
    atk: 430,
    def: 723,
    res: 0,
    block: 3,
    interval: 1.2,
    potential: [0, 0, 30, 0, 0],
    trust: [0, 60, 60, 0, 0],
    moduleX: [200, 0, 140, 0, 0],
    moduleY: [0, 70, 100, 0, 0],
  },
  {
    name: "イフリータ",
    rarity: 6,
    class: "術師",
    hp: 1680,
    atk: 870,
    def: 130,
    res: 0,
    block: 1,
    interval: 2.9,
    potential: [0, 35, 0, 0, 0],
    trust: [0, 110, 0, 0, 0],
    moduleX: [0, 72, 0, 0, 7],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "ラップランド",
    rarity: 5,
    class: "前衛",
    hp: 2350,
    atk: 685,
    def: 365,
    res: 0,
    block: 2,
    interval: 1.3,
    potential: [0, 25, 0, 0, 0],
    trust: [0, 75, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "アステジーニ",
    rarity: 5,
    class: "術師",
    hp: 1440,
    atk: 630,
    def: 122,
    res: 20,
    block: 1,
    interval: 2.3,
    potential: [0, 28, 0, 0, 0],
    trust: [0, 75, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [120, 74, 0, 0, 0],
  },
  {
    name: "ビーハンター",
    rarity: 4,
    class: "前衛",
    hp: 2435,
    atk: 513,
    def: 312,
    res: 0,
    block: 1,
    interval: 0.78,
    potential: [180, 0, 0, 0, 0],
    trust: [0, 60, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "メイ",
    rarity: 4,
    class: "狙撃",
    hp: 1632,
    atk: 478,
    def: 105,
    res: 0,
    block: 1,
    interval: 1.0,
    potential: [0, 23, 0, 0, 0],
    trust: [0, 65, 0, 0, 0],
    moduleX: [0, 27, 0, 0, 3],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "ヘイズ",
    rarity: 4,
    class: "術師",
    hp: 1420,
    atk: 583,
    def: 110,
    res: 20,
    block: 1,
    interval: 1.6,
    potential: [100, 0, 0, 0, 0],
    trust: [0, 60, 0, 0, 0],
    moduleX: [0, 40, 25, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "ニアール",
    rarity: 5,
    class: "重装",
    hp: 2780,
    atk: 462,
    def: 575,
    res: 10,
    block: 3,
    interval: 1.2,
    potential: [0, 0, 25, 0, 0],
    trust: [0, 40, 50, 0, 0],
    moduleX: [300, 60, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "プロヴァンス",
    rarity: 5,
    class: "狙撃",
    hp: 1680,
    atk: 781,
    def: 215,
    res: 0,
    block: 1,
    interval: 1.6,
    potential: [0, 30, 0, 0, 0],
    trust: [0, 90, 0, 0, 0],
    moduleX: [0, 55, 45, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "レッド",
    rarity: 5,
    class: "特殊",
    hp: 1505,
    atk: 530,
    def: 302,
    res: 0,
    block: 1,
    interval: 0.93,
    potential: [0, 20, 0, 0, 0],
    trust: [0, 75, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 74, 0, 0, 4],
  },
  {
    name: "スペクター",
    rarity: 5,
    class: "前衛",
    hp: 2630,
    atk: 725,
    def: 335,
    res: 0,
    block: 3,
    interval: 1.2,
    potential: [0, 27, 0, 0, 0],
    trust: [0, 80, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "シャイニング",
    rarity: 6,
    class: "医療",
    hp: 1613,
    atk: 530,
    def: 138,
    res: 0,
    block: 1,
    interval: 2.85,
    potential: [0, 0, 25, 0, 0],
    trust: [0, 80, 20, 0, 0],
    moduleX: [0, 60, 20, 0, 0],
    moduleY: [0, 60, 0, 0, 7],
  },
  {
    name: "スカベンジャー",
    rarity: 4,
    class: "先鋒",
    hp: 1835,
    atk: 470,
    def: 310,
    res: 0,
    block: 2,
    interval: 1.05,
    potential: [0, 25, 0, 0, 0],
    trust: [0, 60, 0, 0, 0],
    moduleX: [0, 36, 25, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "テンニンカ",
    rarity: 4,
    class: "先鋒",
    hp: 1565,
    atk: 520,
    def: 300,
    res: 0,
    block: 1,
    interval: 1.3,
    potential: [0, 0, 22, 0, 0],
    trust: [0, 0, 50, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "クオーラ",
    rarity: 4,
    class: "重装",
    hp: 3105,
    atk: 365,
    def: 690,
    res: 0,
    block: 3,
    interval: 1.2,
    potential: [0, 0, 27, 0, 0],
    trust: [0, 0, 75, 0, 0],
    moduleX: [170, 0, 80, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "インドラ",
    rarity: 5,
    class: "前衛",
    hp: 2565,
    atk: 530,
    def: 350,
    res: 0,
    block: 1,
    interval: 0.78,
    potential: [0, 23, 0, 0, 0],
    trust: [0, 75, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "ファイヤーウォッチ",
    rarity: 5,
    class: "狙撃",
    hp: 1450,
    atk: 1085,
    def: 131,
    res: 0,
    block: 1,
    interval: 2.7,
    potential: [0, 35, 0, 0, 0],
    trust: [0, 90, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [130, 87, 0, 0, 0],
  },
  {
    name: "コンビクション",
    rarity: 4,
    class: "前衛",
    hp: 3483,
    atk: 929,
    def: 166,
    res: 0,
    block: 1,
    interval: 1.5,
    potential: [0, 0, 0, 0, 0],
    trust: [222, 22, 22, 0, 0],
    moduleX: [0, 80, 0, 0, 4],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "ナイトメア",
    rarity: 5,
    class: "術師",
    hp: 1510,
    atk: 622,
    def: 120,
    res: 20,
    block: 1,
    interval: 1.6,
    potential: [0, 26, 0, 0, 0],
    trust: [0, 70, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 50, 0, 0, 5],
  },
  {
    name: "スカイフレア",
    rarity: 5,
    class: "術師",
    hp: 1620,
    atk: 784,
    def: 122,
    res: 20,
    block: 1,
    interval: 2.9,
    potential: [0, 33, 0, 0, 0],
    trust: [0, 90, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 70, 0, 0, 5],
  },
  {
    name: "ヴァルカン",
    rarity: 5,
    class: "重装",
    hp: 3688,
    atk: 820,
    def: 585,
    res: 10,
    block: 3,
    interval: 1.6,
    potential: [250, 0, 0, 0, 0],
    trust: [400, 50, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "シルバーアッシュ",
    rarity: 6,
    class: "前衛",
    hp: 2560,
    atk: 713,
    def: 397,
    res: 10,
    block: 2,
    interval: 1.3,
    potential: [0, 26, 0, 0, 0],
    trust: [0, 50, 50, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "ワルファリン",
    rarity: 5,
    class: "医療",
    hp: 1520,
    atk: 505,
    def: 125,
    res: 0,
    block: 1,
    interval: 2.85,
    potential: [0, 27, 0, 0, 0],
    trust: [0, 75, 0, 0, 0],
    moduleX: [80, 47, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "パフューマー",
    rarity: 4,
    class: "医療",
    hp: 1560,
    atk: 320,
    def: 145,
    res: 0,
    block: 1,
    interval: 2.85,
    potential: [0, 19, 0, 0, 0],
    trust: [150, 25, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [90, 40, 0, 0, 0],
  },
  {
    name: "アーススピリット",
    rarity: 4,
    class: "補助",
    hp: 1205,
    atk: 480,
    def: 101,
    res: 20,
    block: 1,
    interval: 1.9,
    potential: [0, 21, 0, 0, 0],
    trust: [0, 50, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [130, 0, 38, 0, 0],
  },
  {
    name: "クリフハート",
    rarity: 5,
    class: "特殊",
    hp: 1970,
    atk: 765,
    def: 340,
    res: 0,
    block: 2,
    interval: 1.8,
    potential: [0, 0, 0, 0, 8],
    trust: [0, 70, 0, 0, 0],
    moduleX: [0, 40, 31, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "プラマニクス",
    rarity: 5,
    class: "補助",
    hp: 1605,
    atk: 430,
    def: 102,
    res: 25,
    block: 1,
    interval: 1.6,
    potential: [0, 0, 0, 8, 0],
    trust: [0, 65, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },

  {
    name: "ナイチンゲール",
    rarity: 6,
    class: "医療",
    hp: 1705,
    atk: 350,
    def: 169,
    res: 5,
    block: 1,
    interval: 2.85,
    potential: [0, 0, 0, 10, 0],
    trust: [0, 70, 0, 0, 0],
    moduleX: [0, 65, 0, 5, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "エイヤフィヤトラ",
    rarity: 6,
    class: "術師",
    hp: 1743,
    atk: 645,
    def: 122,
    res: 20,
    block: 1,
    interval: 1.6,
    potential: [0, 27, 0, 0, 0],
    trust: [0, 90, 0, 0, 0],
    moduleX: [180, 65, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "ガヴィル",
    rarity: 4,
    class: "医療",
    hp: 1580,
    atk: 450,
    def: 152,
    res: 0,
    block: 1,
    interval: 2.85,
    potential: [0, 23, 0, 0, 0],
    trust: [0, 30, 30, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [70, 35, 0, 0, 0],
  },
  {
    name: "ムース",
    rarity: 4,
    class: "前衛",
    hp: 2345,
    atk: 644,
    def: 357,
    res: 15,
    block: 1,
    interval: 1.25,
    potential: [0, 26, 0, 0, 0],
    trust: [0, 35, 35, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "ヴァーミル",
    rarity: 4,
    class: "狙撃",
    hp: 1230,
    atk: 485,
    def: 162,
    res: 0,
    block: 1,
    interval: 1.0,
    potential: [0, 24, 0, 0, 0],
    trust: [0, 65, 0, 0, 0],
    moduleX: [170, 31, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "フロストリーフ",
    rarity: 4,
    class: "前衛",
    hp: 2260,
    atk: 660,
    def: 323,
    res: 10,
    block: 1,
    interval: 1.3,
    potential: [0, 0, 0, 0, 8],
    trust: [0, 0, 55, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "プリュム",
    rarity: 3,
    class: "先鋒",
    hp: 1226,
    atk: 445,
    def: 279,
    res: 0,
    block: 1,
    interval: 1.0,
    potential: [0, 21, 0, 0, 0],
    trust: [0, 50, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "ロサ",
    rarity: 6,
    class: "狙撃",
    hp: 1755,
    atk: 1032,
    def: 122,
    res: 0,
    block: 1,
    interval: 2.4,
    potential: [0, 34, 0, 0, 0],
    trust: [0, 110, 0, 0, 0],
    moduleX: [0, 90, 45, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "ケオベ",
    rarity: 6,
    class: "術師",
    hp: 1565,
    atk: 667,
    def: 128,
    res: 20,
    block: 1,
    interval: 1.6,
    potential: [0, 27, 0, 0, 0],
    trust: [0, 90, 0, 0, 0],
    moduleX: [180, 65, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "イースチナ",
    rarity: 5,
    class: "補助",
    hp: 1280,
    atk: 518,
    def: 104,
    res: 0,
    block: 1,
    interval: 1.9,
    potential: [0, 23, 0, 0, 0],
    trust: [0, 65, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [160, 0, 0, 0, 5],
  },
  {
    name: "マッターホルン",
    rarity: 4,
    class: "重装",
    hp: 3235,
    atk: 375,
    def: 670,
    res: 5,
    block: 3,
    interval: 1.2,
    potential: [250, 0, 0, 0, 0],
    trust: [385, 0, 0, 0, 0],
    moduleX: [380, 0, 50, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "グム",
    rarity: 4,
    class: "重装",
    hp: 2550,
    atk: 435,
    def: 562,
    res: 10,
    block: 3,
    interval: 1.2,
    potential: [0, 21, 0, 0, 0],
    trust: [400, 0, 0, 0, 0],
    moduleX: [250, 55, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "クーリエ",
    rarity: 4,
    class: "先鋒",
    hp: 1985,
    atk: 735,
    def: 322,
    res: 0,
    block: 2,
    interval: 1.05,
    potential: [0, 0, 23, 0, 0],
    trust: [0, 0, 60, 0, 0],
    moduleX: [195, 0, 30, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "ニェン",
    rarity: 6,
    class: "重装",
    hp: 3699,
    atk: 619,
    def: 726,
    res: 0,
    block: 3,
    interval: 1.5,
    potential: [0, 24, 30, 0, 0],
    trust: [400, 0, 70, 0, 0],
    moduleX: [375, 50, 80, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "クロワッサン",
    rarity: 5,
    class: "重装",
    hp: 3520,
    atk: 380,
    def: 710,
    res: 0,
    block: 3,
    interval: 1.2,
    potential: [0, 0, 26, 0, 0],
    trust: [150, 0, 60, 0, 0],
    moduleX: [350, 0, 68, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "サリア",
    rarity: 6,
    class: "重装",
    hp: 3150,
    atk: 485,
    def: 595,
    res: 10,
    block: 3,
    interval: 1.2,
    potential: [0, 0, 27, 0, 0],
    trust: [0, 50, 60, 0, 0],
    moduleX: [350, 70, 0, 0, 0],
    moduleY: [270, 50, 50, 0, 0],
  },
  {
    name: "シー",
    rarity: 6,
    class: "術師",
    hp: 1801,
    atk: 918,
    def: 127,
    res: 20,
    block: 1,
    interval: 2.9,
    potential: [0, 34, 0, 0, 0],
    trust: [0, 110, 0, 0, 0],
    moduleX: [190, 80, 0, 0, 0],
    moduleY: [0, 82, 0, 0, 7],
  },
  {
    name: "リィン",
    rarity: 6,
    class: "補助",
    hp: 1079,
    atk: 473,
    def: 138,
    res: 20,
    block: 1,
    interval: 1.6,
    potential: [0, 24, 0, 0, 0],
    trust: [350, 35, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [150, 50, 0, 0, 0],
  },
  {
    name: "プラチナ",
    rarity: 5,
    class: "狙撃",
    hp: 1550,
    atk: 505,
    def: 165,
    res: 0,
    block: 1,
    interval: 1.0,
    potential: [0, 23, 0, 0, 0],
    trust: [0, 75, 0, 0, 0],
    moduleX: [170, 40, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "スチュワード",
    rarity: 3,
    class: "術師",
    hp: 1100,
    atk: 470,
    def: 90,
    res: 15,
    block: 1,
    interval: 1.6,
    potential: [0, 23, 0, 0, 0],
    trust: [0, 50, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "アドナキエル",
    rarity: 3,
    class: "狙撃",
    hp: 1080,
    atk: 365,
    def: 134,
    res: 0,
    block: 1,
    interval: 1.0,
    potential: [0, 23, 0, 0, 0],
    trust: [0, 50, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "マンティコア",
    rarity: 5,
    class: "特殊",
    hp: 1630,
    atk: 811,
    def: 343,
    res: 30,
    block: 0,
    interval: 3.5,
    potential: [0, 30, 0, 0, 0],
    trust: [0, 60, 30, 0, 0],
    moduleX: [0, 85, 31, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "アンセル",
    rarity: 3,
    class: "医療",
    hp: 1135,
    atk: 362,
    def: 109,
    res: 0,
    block: 1,
    interval: 2.85,
    potential: [0, 20, 0, 0, 0],
    trust: [0, 45, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "カーディ",
    rarity: 3,
    class: "重装",
    hp: 2130,
    atk: 305,
    def: 475,
    res: 0,
    block: 3,
    interval: 1.2,
    potential: [200, 0, 0, 0, 0],
    trust: [300, 0, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "カフカ",
    rarity: 5,
    class: "特殊",
    hp: 1675,
    atk: 525,
    def: 311,
    res: 0,
    block: 1,
    interval: 0.93,
    potential: [150, 0, 0, 0, 0],
    trust: [350, 0, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [120, 60, 0, 0, 0],
  },
  {
    name: "メランサ",
    rarity: 3,
    class: "前衛",
    hp: 2745,
    atk: 738,
    def: 155,
    res: 0,
    block: 1,
    interval: 1.5,
    potential: [0, 25, 0, 0, 0],
    trust: [0, 65, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "ノーシス",
    rarity: 6,
    class: "補助",
    hp: 2035,
    atk: 455,
    def: 132,
    res: 25,
    block: 1,
    interval: 1.6,
    potential: [0, 33, 0, 0, 0],
    trust: [0, 80, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "モスティマ",
    rarity: 6,
    class: "術師",
    hp: 1831,
    atk: 834,
    def: 132,
    res: 20,
    block: 1,
    interval: 2.9,
    potential: [0, 34, 0, 0, 0],
    trust: [0, 105, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 82, 0, 0, 7],
  },
  {
    name: "アンドレアナ",
    rarity: 5,
    class: "狙撃",
    hp: 1498,
    atk: 1070,
    def: 128,
    res: 0,
    block: 1,
    interval: 2.7,
    potential: [0, 35, 0, 0, 0],
    trust: [300, 40, 0, 0, 0],
    moduleX: [121, 91, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "メテオリーテ",
    rarity: 5,
    class: "狙撃",
    hp: 1505,
    atk: 865,
    def: 116,
    res: 0,
    block: 1,
    interval: 2.8,
    potential: [0, 35, 0, 0, 0],
    trust: [0, 85, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [180, 65, 0, 0, 0],
  },
  {
    name: "グラニ",
    rarity: 5,
    class: "先鋒",
    hp: 2235,
    atk: 552,
    def: 367,
    res: 0,
    block: 1,
    interval: 1.0,
    potential: [0, 0, 0, 0, 0],
    trust: [0, 0, 70, 0, 0],
    moduleX: [200, 0, 67, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "ウン",
    rarity: 5,
    class: "重装",
    hp: 2823,
    atk: 442,
    def: 585,
    res: 10,
    block: 3,
    interval: 1.2,
    potential: [0, 0, 25, 0, 0],
    trust: [200, 0, 60, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [330, 0, 45, 0, 0],
  },
  {
    name: "ア",
    rarity: 6,
    class: "特殊",
    hp: 2034,
    atk: 703,
    def: 152,
    res: 10,
    block: 1,
    interval: 1.3,
    potential: [150, 0, 0, 0, 0],
    trust: [300, 50, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "バグパイプ",
    rarity: 6,
    class: "先鋒",
    hp: 2484,
    atk: 586,
    def: 382,
    res: 0,
    block: 1,
    interval: 1.0,
    potential: [0, 25, 0, 0, 0],
    trust: [0, 85, 0, 0, 0],
    moduleX: [180, 73, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "グラベル",
    rarity: 4,
    class: "特殊",
    hp: 1420,
    atk: 452,
    def: 335,
    res: 0,
    block: 1,
    interval: 0.93,
    potential: [160, 0, 0, 0, 0],
    trust: [300, 0, 0, 0, 0],
    moduleX: [135, 0, 60, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "ロープ",
    rarity: 4,
    class: "特殊",
    hp: 1720,
    atk: 728,
    def: 325,
    res: 0,
    block: 2,
    interval: 1.8,
    potential: [0, 0, 22, 0, 0],
    trust: [0, 0, 60, 0, 0],
    moduleX: [200, 31, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "バニラ",
    rarity: 3,
    class: "先鋒",
    hp: 1270,
    atk: 355,
    def: 240,
    res: 0,
    block: 2,
    interval: 1.05,
    potential: [0, 20, 0, 0, 0],
    trust: [0, 50, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "ジェシカ",
    rarity: 4,
    class: "狙撃",
    hp: 1320,
    atk: 475,
    def: 154,
    res: 0,
    block: 1,
    interval: 1.0,
    potential: [0, 23, 0, 0, 0],
    trust: [0, 65, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 30, 30, 0, 0],
  },
  {
    name: "サベージ",
    rarity: 5,
    class: "前衛",
    hp: 2430,
    atk: 705,
    def: 320,
    res: 0,
    block: 3,
    interval: 1.2,
    potential: [250, 35, 0, 0, 0],
    trust: [0, 0, 40, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "バイビーク",
    rarity: 5,
    class: "前衛",
    hp: 2550,
    atk: 602,
    def: 332,
    res: 0,
    block: 2,
    interval: 1.3,
    potential: [0, 22, 0, 0, 0],
    trust: [0, 80, 0, 0, 0],
    moduleX: [0, 65, 0, 0, 5],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "ワイフー",
    rarity: 5,
    class: "特殊",
    hp: 1455,
    atk: 536,
    def: 304,
    res: 0,
    block: 1,
    interval: 0.93,
    potential: [0, 0, 19, 0, 0],
    trust: [0, 50, 30, 0, 0],
    moduleX: [0, 95, 65, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "グレイ",
    rarity: 4,
    class: "術師",
    hp: 1537,
    atk: 699,
    def: 130,
    res: 20,
    block: 1,
    interval: 2.9,
    potential: [0, 0, 0, 0, 6],
    trust: [300, 0, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [170, 0, 0, 0, 5],
  },
  {
    name: "メイヤー",
    rarity: 5,
    class: "補助",
    hp: 1068,
    atk: 443,
    def: 130,
    res: 20,
    block: 1,
    interval: 1.6,
    potential: [0, 0, 0, 8, 0],
    trust: [200, 35, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [120, 40, 0, 0, 0],
  },
  {
    name: "マゼラン",
    rarity: 6,
    class: "補助",
    hp: 1103,
    atk: 469,
    def: 140,
    res: 20,
    block: 1,
    interval: 1.6,
    potential: [0, 23, 0, 0, 0],
    trust: [300, 40, 0, 0, 0],
    moduleX: [150, 50, 0, 0, 0],
    moduleY: [0, 40, 40, 0, 0],
  },
  {
    name: "ファントム",
    rarity: 6,
    class: "特殊",
    hp: 1645,
    atk: 558,
    def: 322,
    res: 0,
    block: 1,
    interval: 0.93,
    potential: [130, 22, 0, 0, 0],
    trust: [0, 90, 0, 0, 0],
    moduleX: [140, 73, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "スカジ",
    rarity: 6,
    class: "前衛",
    hp: 3866,
    atk: 1015,
    def: 263,
    res: 0,
    block: 1,
    interval: 1.5,
    potential: [0, 33, 0, 0, 0],
    trust: [0, 80, 40, 0, 0],
    moduleX: [320, 105, 0, 0, 0],
    moduleY: [450, 85, 0, 0, 0],
  },
  {
    name: "マウンテン",
    rarity: 6,
    class: "前衛",
    hp: 2745,
    atk: 587,
    def: 299,
    res: 0,
    block: 1,
    interval: 0.78,
    potential: [0, 24, 0, 0, 0],
    trust: [0, 45, 45, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "シャマレ",
    rarity: 5,
    class: "補助",
    hp: 1728,
    atk: 408,
    def: 105,
    res: 25,
    block: 1,
    interval: 1.6,
    potential: [0, 0, 0, 8, 0],
    trust: [0, 65, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "リード",
    rarity: 5,
    class: "先鋒",
    hp: 2215,
    atk: 562,
    def: 364,
    res: 0,
    block: 1,
    interval: 1.0,
    potential: [0, 25, 0, 0, 0],
    trust: [0, 70, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [180, 65, 0, 0, 0],
  },
  {
    name: "ジュナー",
    rarity: 4,
    class: "重装",
    hp: 3007,
    atk: 583,
    def: 548,
    res: 15,
    block: 3,
    interval: 1.6,
    potential: [0, 23, 20, 0, 0],
    trust: [0, 65, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "ポデンコ",
    rarity: 4,
    class: "補助",
    hp: 1163,
    atk: 492,
    def: 96,
    res: 20,
    block: 1,
    interval: 1.9,
    potential: [0, 21, 0, 0, 0],
    trust: [0, 50, 0, 0, 0],
    moduleX: [110, 40, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "ジェイ",
    rarity: 4,
    class: "特殊",
    hp: 2284,
    atk: 674,
    def: 378,
    res: 0,
    block: 1,
    interval: 1.0,
    potential: [0, 23, 0, 0, 0],
    trust: [200, 40, 0, 0, 0],
    moduleX: [0, 50, 50, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "アレーン",
    rarity: 4,
    class: "前衛",
    hp: 2250,
    atk: 640,
    def: 340,
    res: 0,
    block: 2,
    interval: 1.3,
    potential: [0, 18, 0, 0, 0],
    trust: [0, 55, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "ウィスラッシュ",
    rarity: 5,
    class: "前衛",
    hp: 1932,
    atk: 645,
    def: 420,
    res: 0,
    block: 2,
    interval: 1.05,
    potential: [0, 0, 0, 0, 0],
    trust: [0, 30, 40, 0, 0],
    moduleX: [0, 52, 52, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "ブリーズ",
    rarity: 5,
    class: "医療",
    hp: 1595,
    atk: 343,
    def: 153,
    res: 0,
    block: 1,
    interval: 2.85,
    potential: [0, 20, 0, 0, 0],
    trust: [200, 30, 0, 0, 0],
    moduleX: [100, 47, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "アステシア",
    rarity: 5,
    class: "前衛",
    hp: 2523,
    atk: 660,
    def: 393,
    res: 15,
    block: 1,
    interval: 1.25,
    potential: [0, 23, 0, 0, 0],
    trust: [0, 30, 55, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "ショウ",
    rarity: 4,
    class: "特殊",
    hp: 1785,
    atk: 580,
    def: 365,
    res: 0,
    block: 2,
    interval: 1.2,
    potential: [140, 0, 0, 0, 0],
    trust: [200, 35, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [130, 33, 22, 0, 0],
  },
  {
    name: "オーキッド",
    rarity: 3,
    class: "補助",
    hp: 935,
    atk: 378,
    def: 83,
    res: 15,
    block: 1,
    interval: 1.9,
    potential: [0, 19, 0, 0, 0],
    trust: [0, 40, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "イグゼキュター",
    rarity: 5,
    class: "狙撃",
    hp: 2330,
    atk: 720,
    def: 185,
    res: 0,
    block: 1,
    interval: 2.3,
    potential: [0, 29, 0, 0, 0],
    trust: [0, 65, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "カタパルト",
    rarity: 3,
    class: "狙撃",
    hp: 1150,
    atk: 617,
    def: 85,
    res: 0,
    block: 1,
    interval: 2.8,
    potential: [0, 27, 0, 0, 0],
    trust: [0, 55, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "スポット",
    rarity: 3,
    class: "重装",
    hp: 1833,
    atk: 320,
    def: 442,
    res: 10,
    block: 3,
    interval: 1.2,
    potential: [0, 0, 24, 0, 0],
    trust: [0, 30, 30, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "ヴィグナ",
    rarity: 4,
    class: "先鋒",
    hp: 1845,
    atk: 558,
    def: 351,
    res: 0,
    block: 1,
    interval: 1.0,
    potential: [0, 24, 0, 0, 0],
    trust: [0, 60, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [110, 65, 0, 0, 0],
  },
  {
    name: "ポプカル",
    rarity: 3,
    class: "前衛",
    hp: 1858,
    atk: 495,
    def: 245,
    res: 0,
    block: 2,
    interval: 1.2,
    potential: [0, 23, 0, 0, 0],
    trust: [0, 50, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "ミッドナイト",
    rarity: 3,
    class: "前衛",
    hp: 1653,
    atk: 497,
    def: 282,
    res: 10,
    block: 2,
    interval: 1.3,
    potential: [0, 22, 0, 0, 0],
    trust: [0, 50, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "マトイマル",
    rarity: 4,
    class: "前衛",
    hp: 3640,
    atk: 916,
    def: 156,
    res: 0,
    block: 1,
    interval: 1.5,
    potential: [180, 0, 0, 0, 0],
    trust: [450, 0, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [390, 55, 0, 0, 0],
  },
  {
    name: "Castle-3",
    rarity: 1,
    class: "前衛",
    hp: 1191,
    atk: 353,
    def: 90,
    res: 0,
    block: 1,
    interval: 1.5,
    potential: [0, 0, 0, 0, 0],
    trust: [200, 60, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },

  {
    name: "Lancet-2",
    rarity: 1,
    class: "医療",
    hp: 435,
    atk: 70,
    def: 27,
    res: 0,
    block: 1,
    interval: 2.85,
    potential: [0, 0, 0, 0, 0],
    trust: [100, 40, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "アンジェリーナ",
    rarity: 6,
    class: "補助",
    hp: 1385,
    atk: 542,
    def: 120,
    res: 25,
    block: 1,
    interval: 1.9,
    potential: [0, 25, 0, 0, 0],
    trust: [0, 75, 0, 0, 0],
    moduleX: [100, 20, 0, 0, 6],
    moduleY: [120, 50, 0, 0, 0],
  },
  {
    name: "フィアメッタ",
    rarity: 6,
    class: "狙撃",
    hp: 1926,
    atk: 861,
    def: 156,
    res: 0,
    block: 1,
    interval: 2.8,
    potential: [0, 35, 0, 0, 0],
    trust: [0, 100, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 70, 43, 0, 0],
  },
  {
    name: "ソーンズ",
    rarity: 6,
    class: "前衛",
    hp: 2612,
    atk: 711,
    def: 402,
    res: 10,
    block: 2,
    interval: 1.3,
    potential: [0, 26, 0, 0, 0],
    trust: [0, 30, 70, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "エアースカーペ",
    rarity: 5,
    class: "前衛",
    hp: 2420,
    atk: 670,
    def: 375,
    res: 10,
    block: 2,
    interval: 1.3,
    potential: [0, 26, 0, 0, 0],
    trust: [0, 75, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "カッター",
    rarity: 4,
    class: "前衛",
    hp: 2320,
    atk: 571,
    def: 625,
    res: 0,
    block: 2,
    interval: 1.3,
    potential: [0, 21, 0, 0, 0],
    trust: [0, 70, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [150, 65, 0, 0, 0],
  },
  {
    name: "ススーロ",
    rarity: 4,
    class: "医療",
    hp: 1345,
    atk: 488,
    def: 122,
    res: 0,
    block: 1,
    interval: 2.85,
    potential: [0, 23, 0, 0, 0],
    trust: [0, 60, 0, 0, 0],
    moduleX: [100, 0, 0, 0, 5],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "アンブリエル",
    rarity: 4,
    class: "狙撃",
    hp: 1565,
    atk: 977,
    def: 120,
    res: 0,
    block: 1,
    interval: 2.7,
    potential: [0, 0, 0, 0, 6],
    trust: [0, 75, 0, 0, 0],
    moduleX: [95, 81, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "ヘラグ",
    rarity: 6,
    class: "前衛",
    hp: 3825,
    atk: 762,
    def: 334,
    res: 0,
    block: 1,
    interval: 1.2,
    potential: [0, 26, 0, 0, 0],
    trust: [400, 70, 0, 0, 0],
    moduleX: [350, 90, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "ヘビーレイン",
    rarity: 5,
    class: "重装",
    hp: 3380,
    atk: 378,
    def: 721,
    res: 0,
    block: 3,
    interval: 1.2,
    potential: [0, 0, 0, 0, 0],
    trust: [350, 0, 35, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [375, 0, 65, 0, 0],
  },
  {
    name: "レイズ",
    rarity: 5,
    class: "術師",
    hp: 1443,
    atk: 635,
    def: 119,
    res: 20,
    block: 1,
    interval: 2.3,
    potential: [0, 28, 0, 0, 0],
    trust: [0, 75, 0, 0, 0],
    moduleX: [105, 75, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "スワイヤー",
    rarity: 5,
    class: "前衛",
    hp: 1914,
    atk: 656,
    def: 413,
    res: 0,
    block: 2,
    interval: 1.05,
    potential: [0, 26, 0, 0, 0],
    trust: [0, 40, 30, 0, 0],
    moduleX: [170, 75, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "リー",
    rarity: 6,
    class: "特殊",
    hp: 2427,
    atk: 789,
    def: 465,
    res: 0,
    block: 1,
    interval: 1.0,
    potential: [0, 30, 0, 0, 0],
    trust: [300, 55, 0, 0, 0],
    moduleX: [300, 74, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "マドロック",
    rarity: 6,
    class: "重装",
    hp: 3928,
    atk: 882,
    def: 602,
    res: 10,
    block: 3,
    interval: 1.6,
    potential: [0, 0, 29, 0, 0],
    trust: [500, 0, 60, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "バイソン",
    rarity: 5,
    class: "重装",
    hp: 3456,
    atk: 375,
    def: 701,
    res: 0,
    block: 3,
    interval: 1.2,
    potential: [0, 0, 0, 0, 0],
    trust: [0, 0, 80, 0, 0],
    moduleX: [250, 0, 85, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "グラウコス",
    rarity: 5,
    class: "補助",
    hp: 1267,
    atk: 505,
    def: 100,
    res: 0,
    block: 1,
    interval: 1.9,
    potential: [0, 23, 0, 0, 0],
    trust: [300, 35, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "カシャ",
    rarity: 4,
    class: "術師",
    hp: 1440,
    atk: 315,
    def: 120,
    res: 20,
    block: 1,
    interval: 1.3,
    potential: [0, 0, 0, 0, 6],
    trust: [0, 60, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "アルケット",
    rarity: 6,
    class: "狙撃",
    hp: 1705,
    atk: 528,
    def: 172,
    res: 0,
    block: 1,
    interval: 1.0,
    potential: [0, 27, 0, 0, 0],
    trust: [0, 90, 0, 0, 0],
    moduleX: [160, 48, 0, 0, 0],
    moduleY: [0, 24, 24, 0, 4],
  },
  {
    name: "シーン",
    rarity: 5,
    class: "補助",
    hp: 1105,
    atk: 432,
    def: 155,
    res: 20,
    block: 1,
    interval: 1.6,
    potential: [0, 0, 0, 8, 0],
    trust: [200, 0, 35, 0, 0],
    moduleX: [0, 36, 30, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "シデロカ",
    rarity: 5,
    class: "前衛",
    hp: 2845,
    atk: 620,
    def: 369,
    res: 15,
    block: 1,
    interval: 1.25,
    potential: [0, 0, 0, 0, 0],
    trust: [500, 0, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "ビーズワクス",
    rarity: 5,
    class: "術師",
    hp: 2005,
    atk: 735,
    def: 205,
    res: 15,
    block: 1,
    interval: 2.0,
    potential: [0, 30, 0, 0, 0],
    trust: [0, 70, 20, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "フォリニック",
    rarity: 5,
    class: "医療",
    hp: 1585,
    atk: 479,
    def: 133,
    res: 0,
    block: 1,
    interval: 2.85,
    potential: [0, 0, 0, 0, 0],
    trust: [200, 50, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [120, 0, 0, 0, 6],
  },
  {
    name: "ツキノギ",
    rarity: 5,
    class: "補助",
    hp: 1720,
    atk: 445,
    def: 175,
    res: 25,
    block: 1,
    interval: 1.6,
    potential: [160, 0, 0, 0, 0],
    trust: [300, 40, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "アイリス",
    rarity: 5,
    class: "術師",
    hp: 1535,
    atk: 1259,
    def: 125,
    res: 0,
    block: 1,
    interval: 3.0,
    potential: [0, 45, 0, 0, 0],
    trust: [0, 130, 0, 0, 0],
    moduleX: [0, 82, 0, 4, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "ウタゲ",
    rarity: 4,
    class: "前衛",
    hp: 3444,
    atk: 693,
    def: 312,
    res: 0,
    block: 1,
    interval: 1.2,
    potential: [0, 23, 0, 0, 0],
    trust: [0, 30, 40, 0, 0],
    moduleX: [240, 60, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "シュヴァルツ",
    rarity: 6,
    class: "狙撃",
    hp: 1833,
    atk: 840,
    def: 225,
    res: 0,
    block: 1,
    interval: 1.6,
    potential: [0, 30, 0, 0, 0],
    trust: [0, 100, 0, 0, 0],
    moduleX: [170, 75, 0, 0, 0],
    moduleY: [0, 120, 16, 0, 0],
  },
  {
    name: "イーサン",
    rarity: 4,
    class: "特殊",
    hp: 1530,
    atk: 742,
    def: 337,
    res: 30,
    block: 0,
    interval: 3.5,
    potential: [150, 0, 0, 0, 0],
    trust: [450, 0, 0, 0, 0],
    moduleX: [300, 60, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "ジャッキー",
    rarity: 4,
    class: "前衛",
    hp: 2378,
    atk: 529,
    def: 308,
    res: 0,
    block: 1,
    interval: 0.78,
    potential: [0, 21, 0, 0, 0],
    trust: [0, 60, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "キアーベ",
    rarity: 5,
    class: "先鋒",
    hp: 1824,
    atk: 522,
    def: 342,
    res: 0,
    block: 2,
    interval: 1.05,
    potential: [0, 24, 0, 0, 0],
    trust: [0, 70, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 42, 35, 0, 0],
  },
  {
    name: "セイロン",
    rarity: 5,
    class: "医療",
    hp: 1455,
    atk: 468,
    def: 126,
    res: 10,
    block: 1,
    interval: 2.85,
    potential: [0, 0, 0, 0, 0],
    trust: [200, 40, 0, 0, 0],
    moduleX: [0, 45, 0, 5, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "スルト",
    rarity: 6,
    class: "前衛",
    hp: 2916,
    atk: 672,
    def: 414,
    res: 15,
    block: 1,
    interval: 1.25,
    potential: [0, 28, 0, 0, 0],
    trust: [0, 100, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "アシッドドロップ",
    rarity: 4,
    class: "狙撃",
    hp: 1576,
    atk: 735,
    def: 209,
    res: 0,
    block: 1,
    interval: 1.6,
    potential: [0, 30, 0, 0, 0],
    trust: [0, 80, 0, 0, 0],
    moduleX: [0, 0, 50, 0, 5],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "エイプリル",
    rarity: 5,
    class: "狙撃",
    hp: 1280,
    atk: 528,
    def: 160,
    res: 0,
    block: 1,
    interval: 1.0,
    potential: [0, 23, 0, 0, 0],
    trust: [0, 75, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [190, 32, 0, 0, 0],
  },
  {
    name: "ブローカ",
    rarity: 5,
    class: "前衛",
    hp: 2335,
    atk: 762,
    def: 366,
    res: 0,
    block: 3,
    interval: 1.2,
    potential: [0, 28, 0, 0, 0],
    trust: [0, 80, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "トギフォンス",
    rarity: 5,
    class: "狙撃",
    hp: 1667,
    atk: 954,
    def: 123,
    res: 0,
    block: 1,
    interval: 2.4,
    potential: [0, 34, 0, 0, 0],
    trust: [0, 95, 0, 0, 0],
    moduleX: [0, 75, 35, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "サガ",
    rarity: 6,
    class: "先鋒",
    hp: 2205,
    atk: 530,
    def: 372,
    res: 0,
    block: 2,
    interval: 1.05,
    potential: [0, 25, 0, 0, 0],
    trust: [0, 85, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [125, 55, 20, 0, 0],
  },
  {
    name: "スズラン",
    rarity: 6,
    class: "補助",
    hp: 1480,
    atk: 521,
    def: 128,
    res: 25,
    block: 1,
    interval: 1.9,
    potential: [0, 25, 0, 0, 0],
    trust: [0, 75, 0, 0, 0],
    moduleX: [180, 0, 0, 0, 6],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "グレースロート",
    rarity: 5,
    class: "狙撃",
    hp: 1493,
    atk: 513,
    def: 152,
    res: 0,
    block: 1,
    interval: 1.0,
    potential: [0, 23, 0, 0, 0],
    trust: [0, 75, 0, 0, 0],
    moduleX: [120, 45, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "ベナ",
    rarity: 5,
    class: "特殊",
    hp: 2435,
    atk: 682,
    def: 315,
    res: 0,
    block: 2,
    interval: 1.2,
    potential: [0, 0, 0, 0, 0],
    trust: [100, 60, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [280, 55, 0, 0, 0],
  },
  {
    name: "レオンハルト",
    rarity: 5,
    class: "術師",
    hp: 1637,
    atk: 773,
    def: 120,
    res: 20,
    block: 1,
    interval: 2.9,
    potential: [0, 32, 0, 0, 0],
    trust: [0, 90, 0, 0, 0],
    moduleX: [155, 70, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "アスベストス",
    rarity: 5,
    class: "重装",
    hp: 3135,
    atk: 633,
    def: 555,
    res: 15,
    block: 3,
    interval: 1.6,
    potential: [210, 0, 0, 0, 0],
    trust: [0, 40, 40, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "THRM-EX",
    rarity: 1,
    class: "特殊",
    hp: 1443,
    atk: 260,
    def: 443,
    res: 0,
    block: 0,
    interval: 0.93,
    potential: [0, 0, 0, 0, 0],
    trust: [0, 90, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "ゴールデングロー",
    rarity: 6,
    class: "術師",
    hp: 1480,
    atk: 331,
    def: 125,
    res: 0,
    block: 1,
    interval: 1.3,
    potential: [0, 25, 0, 0, 0],
    trust: [0, 60, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "シェーシャ",
    rarity: 5,
    class: "狙撃",
    hp: 1655,
    atk: 833,
    def: 123,
    res: 0,
    block: 1,
    interval: 2.8,
    potential: [0, 33, 0, 0, 0],
    trust: [0, 85, 0, 0, 0],
    moduleX: [0, 60, 43, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "スノーズント",
    rarity: 5,
    class: "特殊",
    hp: 1835,
    atk: 745,
    def: 355,
    res: 0,
    block: 2,
    interval: 1.8,
    potential: [0, 0, 0, 0, 0],
    trust: [300, 0, 40, 0, 0],
    moduleX: [210, 0, 31, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "ミント",
    rarity: 5,
    class: "術師",
    hp: 1945,
    atk: 732,
    def: 196,
    res: 15,
    block: 1,
    interval: 2.0,
    potential: [0, 0, 0, 0, 0],
    trust: [0, 75, 15, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "バブル",
    rarity: 4,
    class: "重装",
    hp: 3416,
    atk: 390,
    def: 645,
    res: 0,
    block: 3,
    interval: 1.2,
    potential: [0, 0, 25, 0, 0],
    trust: [0, 0, 75, 0, 0],
    moduleX: [250, 0, 65, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "セイリュウ",
    rarity: 4,
    class: "医療",
    hp: 1365,
    atk: 454,
    def: 118,
    res: 10,
    block: 1,
    interval: 2.85,
    potential: [0, 23, 0, 0, 0],
    trust: [150, 35, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 32, 32, 0, 0],
  },
  {
    name: "ロスモンティス",
    rarity: 6,
    class: "狙撃",
    hp: 1944,
    atk: 688,
    def: 245,
    res: 15,
    block: 1,
    interval: 2.1,
    potential: [0, 32, 0, 0, 0],
    trust: [0, 60, 30, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "ジャスティスナイト",
    rarity: 1,
    class: "狙撃",
    hp: 495,
    atk: 172,
    def: 41,
    res: 0,
    block: 1,
    interval: 1.0,
    potential: [0, 0, 0, 0, 0],
    trust: [100, 45, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "プリン",
    rarity: 4,
    class: "術師",
    hp: 1326,
    atk: 542,
    def: 108,
    res: 20,
    block: 1,
    interval: 2.3,
    potential: [0, 23, 0, 0, 0],
    trust: [0, 70, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [130, 0, 0, 0, 5],
  },
  {
    name: "九色鹿",
    rarity: 5,
    class: "補助",
    hp: 1685,
    atk: 443,
    def: 179,
    res: 25,
    block: 1,
    interval: 1.6,
    potential: [0, 0, 0, 0, 0],
    trust: [350, 35, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "カゼマル",
    rarity: 5,
    class: "特殊",
    hp: 2372,
    atk: 692,
    def: 318,
    res: 0,
    block: 2,
    interval: 1.2,
    potential: [0, 27, 0, 0, 0],
    trust: [0, 80, 0, 0, 0],
    moduleX: [0, 65, 40, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "イェラ",
    rarity: 5,
    class: "術師",
    hp: 1475,
    atk: 294,
    def: 121,
    res: 20,
    block: 1,
    interval: 1.3,
    potential: [0, 0, 0, 0, 0],
    trust: [0, 60, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "アイリーニ",
    rarity: 6,
    class: "前衛",
    hp: 2935,
    atk: 621,
    def: 349,
    res: 0,
    block: 2,
    interval: 1.3,
    potential: [0, 23, 0, 0, 0],
    trust: [0, 80, 20, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 65, 50, 0, 0],
  },
  {
    name: "ウィーディ",
    rarity: 6,
    class: "特殊",
    hp: 2133,
    atk: 677,
    def: 394,
    res: 0,
    block: 2,
    interval: 1.2,
    potential: [140, 0, 0, 0, 8],
    trust: [0, 45, 45, 0, 0],
    moduleX: [210, 72, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "エフイーター",
    rarity: 5,
    class: "特殊",
    hp: 1845,
    atk: 640,
    def: 382,
    res: 0,
    block: 2,
    interval: 1.2,
    potential: [0, 0, 0, 0, 8],
    trust: [300, 45, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [170, 35, 35, 0, 0],
  },
  {
    name: "エンフォーサー",
    rarity: 5,
    class: "特殊",
    hp: 1937,
    atk: 653,
    def: 381,
    res: 0,
    block: 2,
    interval: 1.2,
    potential: [0, 0, 0, 0, 0],
    trust: [350, 35, 0, 0, 0],
    moduleX: [240, 60, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "シャレム",
    rarity: 5,
    class: "重装",
    hp: 3090,
    atk: 649,
    def: 550,
    res: 15,
    block: 1,
    interval: 1.6,
    potential: [0, 25, 0, 0, 0],
    trust: [0, 80, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "エリジウム",
    rarity: 5,
    class: "先鋒",
    hp: 1669,
    atk: 533,
    def: 335,
    res: 0,
    block: 1,
    interval: 1.3,
    potential: [0, 0, 23, 0, 0],
    trust: [0, 0, 60, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "トゥイエ",
    rarity: 5,
    class: "医療",
    hp: 1550,
    atk: 493,
    def: 135,
    res: 0,
    block: 1,
    interval: 2.85,
    potential: [0, 0, 0, 0, 0],
    trust: [0, 75, 0, 0, 0],
    moduleX: [80, 47, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "ホルン",
    rarity: 6,
    class: "重装",
    hp: 3067,
    atk: 936,
    def: 620,
    res: 0,
    block: 3,
    interval: 2.8,
    potential: [0, 30, 0, 0, 0],
    trust: [300, 70, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "エーベンホルツ",
    rarity: 6,
    class: "術師",
    hp: 1678,
    atk: 1400,
    def: 135,
    res: 20,
    block: 1,
    interval: 3.0,
    potential: [0, 52, 0, 0, 0],
    trust: [0, 150, 0, 0, 0],
    moduleX: [0, 90, 0, 0, 5],
    moduleY: [175, 135, 0, 0, 0],
  },
  {
    name: "ルーメン",
    rarity: 6,
    class: "医療",
    hp: 1825,
    atk: 540,
    def: 119,
    res: 0,
    block: 1,
    interval: 2.85,
    potential: [0, 0, 0, 0, 0],
    trust: [0, 45, 30, 0, 0],
    moduleX: [160, 45, 0, 0, 0],
    moduleY: [0, 45, 28, 0, 0],
  },
  {
    name: "ロックロック",
    rarity: 5,
    class: "術師",
    hp: 1468,
    atk: 320,
    def: 123,
    res: 0,
    block: 1,
    interval: 1.3,
    potential: [0, 24, 0, 0, 0],
    trust: [0, 60, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "エラト",
    rarity: 5,
    class: "狙撃",
    hp: 1648,
    atk: 957,
    def: 125,
    res: 0,
    block: 1,
    interval: 2.4,
    potential: [0, 34, 0, 0, 0],
    trust: [150, 70, 0, 0, 0],
    moduleX: [130, 70, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "ハイディ",
    rarity: 5,
    class: "補助",
    hp: 1260,
    atk: 320,
    def: 268,
    res: 0,
    block: 1,
    interval: 1.0,
    potential: [0, 0, 0, 0, 0],
    trust: [250, 40, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "チェストナット",
    rarity: 4,
    class: "医療",
    hp: 1137,
    atk: 389,
    def: 101,
    res: 10,
    block: 1,
    interval: 2.85,
    potential: [0, 15, 0, 0, 0],
    trust: [100, 35, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "ツェルニー",
    rarity: 5,
    class: "重装",
    hp: 3122,
    atk: 625,
    def: 577,
    res: 15,
    block: 3,
    interval: 1.6,
    potential: [0, 0, 0, 0, 0],
    trust: [200, 40, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "ミニマリスト",
    rarity: 5,
    class: "術師",
    hp: 1400,
    atk: 320,
    def: 120,
    res: 20,
    block: 1,
    interval: 1.3,
    potential: [0, 0, 0, 0, 0],
    trust: [100, 40, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "アブサント",
    rarity: 5,
    class: "術師",
    hp: 1420,
    atk: 633,
    def: 124,
    res: 0,
    block: 1,
    interval: 1.6,
    potential: [0, 0, 0, 0, 0],
    trust: [0, 70, 0, 0, 0],
    moduleX: [150, 50, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "ドロシー",
    rarity: 6,
    class: "特殊",
    hp: 1502,
    atk: 581,
    def: 172,
    res: 0,
    block: 1,
    interval: 0.85,
    potential: [0, 27, 0, 0, 0],
    trust: [0, 80, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "パゼオンカ",
    rarity: 6,
    class: "狙撃",
    hp: 1802,
    atk: 876,
    def: 193,
    res: 0,
    block: 1,
    interval: 1.6,
    potential: [0, 30, 0, 0, 0],
    trust: [0, 70, 30, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [170, 75, 0, 0, 0],
  },
  {
    name: "トミミ",
    rarity: 5,
    class: "術師",
    hp: 1920,
    atk: 600,
    def: 119,
    res: 20,
    block: 1,
    interval: 1.6,
    potential: [0, 0, 0, 0, 0],
    trust: [200, 35, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 50, 25, 0, 0],
  },
  {
    name: "ブレミシャイン",
    rarity: 6,
    class: "重装",
    hp: 3242,
    atk: 491,
    def: 581,
    res: 10,
    block: 3,
    interval: 1.2,
    potential: [0, 26, 0, 0, 0],
    trust: [0, 90, 20, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [270, 50, 50, 0, 0],
  },
  {
    name: "ユーネクテス",
    rarity: 6,
    class: "重装",
    hp: 4468,
    atk: 1007,
    def: 615,
    res: 0,
    block: 1,
    interval: 1.6,
    potential: [0, 0, 27, 0, 0],
    trust: [0, 70, 70, 0, 0],
    moduleX: [0, 105, 85, 0, 0],
    moduleY: [0, 85, 110, 0, 0],
  },
  {
    name: "フレイムテイル",
    rarity: 6,
    class: "先鋒",
    hp: 2138,
    atk: 526,
    def: 392,
    res: 0,
    block: 2,
    interval: 1.05,
    potential: [0, 25, 0, 0, 0],
    trust: [0, 85, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [300, 45, 0, 0, 0],
  },
  {
    name: "フリント",
    rarity: 5,
    class: "前衛",
    hp: 2495,
    atk: 545,
    def: 334,
    res: 0,
    block: 1,
    interval: 0.78,
    potential: [0, 24, 0, 0, 0],
    trust: [0, 75, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "オーロラ",
    rarity: 5,
    class: "重装",
    hp: 4027,
    atk: 901,
    def: 640,
    res: 0,
    block: 1,
    interval: 1.6,
    potential: [0, 0, 27, 0, 0],
    trust: [0, 55, 55, 0, 0],
    moduleX: [380, 90, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "ズィマー",
    rarity: 5,
    class: "先鋒",
    hp: 2150,
    atk: 470,
    def: 350,
    res: 0,
    block: 2,
    interval: 1.05,
    potential: [0, 0, 24, 0, 0],
    trust: [0, 0, 70, 0, 0],
    moduleX: [260, 0, 37, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "ラ・プルマ",
    rarity: 5,
    class: "前衛",
    hp: 2250,
    atk: 650,
    def: 452,
    res: 0,
    block: 2,
    interval: 1.3,
    potential: [0, 0, 25, 0, 0],
    trust: [0, 75, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "ウインドフリット",
    rarity: 5,
    class: "補助",
    hp: 2600,
    atk: 565,
    def: 425,
    res: 0,
    block: 2,
    interval: 1.5,
    potential: [0, 25, 0, 0, 0],
    trust: [0, 40, 40, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "アッシュロック",
    rarity: 5,
    class: "重装",
    hp: 3207,
    atk: 865,
    def: 541,
    res: 0,
    block: 3,
    interval: 2.8,
    potential: [0, 32, 0, 0, 0],
    trust: [0, 50, 50, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "ウィスパーレイン",
    rarity: 5,
    class: "医療",
    hp: 1432,
    atk: 492,
    def: 119,
    res: 0,
    block: 1,
    interval: 2.85,
    potential: [0, 23, 0, 0, 0],
    trust: [200, 40, 0, 0, 0],
    moduleX: [140, 40, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "ミヅキ",
    rarity: 6,
    class: "特殊",
    hp: 1758,
    atk: 865,
    def: 356,
    res: 30,
    block: 0,
    interval: 3.5,
    potential: [0, 32, 0, 0, 0],
    trust: [0, 110, 0, 0, 0],
    moduleX: [220, 90, 0, 0, 0],
    moduleY: [0, 70, 0, 0, 7],
  },
  {
    name: "ファートゥース",
    rarity: 6,
    class: "狙撃",
    hp: 1522,
    atk: 1196,
    def: 163,
    res: 0,
    block: 1,
    interval: 2.7,
    potential: [0, 40, 0, 0, 0],
    trust: [0, 100, 0, 0, 0],
    moduleX: [0, 100, 0, 0, 7],
    moduleY: [120, 120, 0, 0, 0],
  },
  {
    name: "カーネリアン",
    rarity: 6,
    class: "術師",
    hp: 2106,
    atk: 846,
    def: 228,
    res: 15,
    block: 1,
    interval: 2.0,
    potential: [0, 34, 0, 0, 0],
    trust: [0, 80, 30, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "パインコーン",
    rarity: 4,
    class: "狙撃",
    hp: 2200,
    atk: 667,
    def: 167,
    res: 0,
    block: 1,
    interval: 2.3,
    potential: [0, 28, 0, 0, 0],
    trust: [0, 55, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "ハニーベリー",
    rarity: 5,
    class: "医療",
    hp: 1458,
    atk: 375,
    def: 107,
    res: 0,
    block: 1,
    interval: 2.85,
    potential: [0, 19, 0, 0, 0],
    trust: [150, 35, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "インディゴ",
    rarity: 4,
    class: "術師",
    hp: 1435,
    atk: 1116,
    def: 117,
    res: 20,
    block: 1,
    interval: 3.0,
    potential: [0, 36, 0, 0, 0],
    trust: [0, 100, 0, 0, 0],
    moduleX: [0, 70, 0, 0, 4],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "ロビン",
    rarity: 5,
    class: "特殊",
    hp: 1442,
    atk: 513,
    def: 166,
    res: 0,
    block: 1,
    interval: 0.85,
    potential: [0, 0, 0, 0, 0],
    trust: [200, 40, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "ビーンストーク",
    rarity: 4,
    class: "先鋒",
    hp: 1569,
    atk: 405,
    def: 125,
    res: 0,
    block: 1,
    interval: 1.0,
    potential: [0, 0, 0, 0, 8],
    trust: [0, 50, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "ウユウ",
    rarity: 5,
    class: "特殊",
    hp: 2398,
    atk: 725,
    def: 396,
    res: 0,
    block: 1,
    interval: 1.0,
    potential: [0, 25, 0, 0, 0],
    trust: [200, 40, 0, 0, 0],
    moduleX: [240, 65, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "パッセンジャー",
    rarity: 6,
    class: "術師",
    hp: 1558,
    atk: 689,
    def: 130,
    res: 0,
    block: 1,
    interval: 2.3,
    potential: [0, 32, 0, 0, 0],
    trust: [0, 85, 0, 0, 0],
    moduleX: [0, 90, 0, 0, 5],
    moduleY: [60, 100, 0, 0, 0],
  },
  {
    name: "グレイディーア",
    rarity: 6,
    class: "特殊",
    hp: 2309,
    atk: 801,
    def: 331,
    res: 0,
    block: 2,
    interval: 1.8,
    potential: [0, 0, 0, 0, 0],
    trust: [0, 50, 50, 0, 0],
    moduleX: [210, 70, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "マルベリー",
    rarity: 5,
    class: "医療",
    hp: 1367,
    atk: 388,
    def: 99,
    res: 10,
    block: 1,
    interval: 2.85,
    potential: [0, 19, 0, 0, 0],
    trust: [150, 35, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "アカフユ",
    rarity: 5,
    class: "前衛",
    hp: 3635,
    atk: 728,
    def: 328,
    res: 0,
    block: 1,
    interval: 1.2,
    potential: [0, 23, 0, 0, 0],
    trust: [0, 30, 55, 0, 0],
    moduleX: [0, 70, 50, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "ブラックナイト",
    rarity: 5,
    class: "先鋒",
    hp: 1625,
    atk: 442,
    def: 133,
    res: 0,
    block: 1,
    interval: 1.0,
    potential: [0, 0, 0, 0, 8],
    trust: [0, 60, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "キララ",
    rarity: 5,
    class: "特殊",
    hp: 1780,
    atk: 798,
    def: 340,
    res: 30,
    block: 0,
    interval: 3.5,
    potential: [0, 30, 0, 0, 0],
    trust: [200, 60, 0, 0, 0],
    moduleX: [330, 60, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "コロセラム",
    rarity: 5,
    class: "術師",
    hp: 1572,
    atk: 760,
    def: 120,
    res: 20,
    block: 1,
    interval: 2.9,
    potential: [0, 33, 0, 0, 0],
    trust: [0, 90, 0, 0, 0],
    moduleX: [190, 60, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "テキーラ",
    rarity: 5,
    class: "前衛",
    hp: 3757,
    atk: 302,
    def: 501,
    res: 15,
    block: 3,
    interval: 1.2,
    potential: [0, 0, 0, 0, 0],
    trust: [230, 50, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "クエルクス",
    rarity: 5,
    class: "補助",
    hp: 1680,
    atk: 463,
    def: 172,
    res: 0,
    block: 1,
    interval: 1.6,
    potential: [160, 0, 0, 0, 0],
    trust: [400, 0, 30, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "ロベルタ",
    rarity: 4,
    class: "補助",
    hp: 2470,
    atk: 535,
    def: 415,
    res: 0,
    block: 2,
    interval: 1.5,
    potential: [0, 0, 35, 0, 0],
    trust: [0, 35, 35, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "サイラッハ",
    rarity: 6,
    class: "先鋒",
    hp: 1835,
    atk: 546,
    def: 367,
    res: 0,
    block: 1,
    interval: 1.3,
    potential: [0, 25, 0, 0, 0],
    trust: [0, 40, 40, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "パラス",
    rarity: 6,
    class: "前衛",
    hp: 1963,
    atk: 687,
    def: 455,
    res: 0,
    block: 2,
    interval: 1.05,
    potential: [0, 25, 0, 0, 0],
    trust: [300, 50, 0, 0, 0],
    moduleX: [210, 83, 0, 0, 0],
    moduleY: [0, 60, 0, 0, 5],
  },
  {
    name: "Ash",
    rarity: 6,
    class: "狙撃",
    hp: 1689,
    atk: 534,
    def: 169,
    res: 0,
    block: 1,
    interval: 1.0,
    potential: [0, 27, 0, 0, 0],
    trust: [0, 90, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [200, 40, 0, 0, 0],
  },
  {
    name: "ワイルドメイン",
    rarity: 5,
    class: "先鋒",
    hp: 2225,
    atk: 558,
    def: 372,
    res: 0,
    block: 1,
    interval: 1.0,
    potential: [0, 0, 0, 0, 0],
    trust: [0, 70, 0, 0, 0],
    moduleX: [0, 60, 0, 0, 5],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "カンタービレ",
    rarity: 5,
    class: "先鋒",
    hp: 1917,
    atk: 560,
    def: 267,
    res: 0,
    block: 1,
    interval: 1.0,
    potential: [0, 0, 0, 0, 5],
    trust: [0, 30, 30, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "ヤトウ",
    rarity: 2,
    class: "先鋒",
    hp: 1030,
    atk: 232,
    def: 192,
    res: 0,
    block: 2,
    interval: 1.05,
    potential: [0, 18, 0, 0, 0],
    trust: [0, 30, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "ノイルホーン",
    rarity: 2,
    class: "重装",
    hp: 1670,
    atk: 240,
    def: 315,
    res: 0,
    block: 3,
    interval: 1.2,
    potential: [90, 0, 0, 0, 0],
    trust: [0, 0, 40, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "レンジャー",
    rarity: 2,
    class: "狙撃",
    hp: 780,
    atk: 269,
    def: 66,
    res: 0,
    block: 1,
    interval: 1.0,
    potential: [0, 0, 0, 0, 12],
    trust: [0, 30, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "ドゥリン",
    rarity: 2,
    class: "術師",
    hp: 952,
    atk: 340,
    def: 62,
    res: 0,
    block: 1,
    interval: 1.6,
    potential: [100, 0, 0, 0, 0],
    trust: [0, 30, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "Blitz",
    rarity: 5,
    class: "重装",
    hp: 3213,
    atk: 445,
    def: 676,
    res: 0,
    block: 3,
    interval: 1.2,
    potential: [0, 25, 0, 0, 0],
    trust: [0, 45, 45, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "Tachanka",
    rarity: 5,
    class: "前衛",
    hp: 2626,
    atk: 621,
    def: 309,
    res: 0,
    block: 2,
    interval: 1.3,
    potential: [0, 0, 0, 0, 0],
    trust: [0, 40, 40, 0, 0],
    moduleX: [0, 55, 55, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "Frost",
    rarity: 5,
    class: "特殊",
    hp: 1359,
    atk: 529,
    def: 157,
    res: 0,
    block: 1,
    interval: 0.85,
    potential: [0, 23, 0, 0, 0],
    trust: [200, 40, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "アオスタ",
    rarity: 5,
    class: "狙撃",
    hp: 2376,
    atk: 691,
    def: 192,
    res: 0,
    block: 1,
    interval: 2.3,
    potential: [0, 26, 0, 0, 0],
    trust: [0, 65, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "プロヴァイゾ",
    rarity: 5,
    class: "補助",
    hp: 1298,
    atk: 513,
    def: 102,
    res: 20,
    block: 1,
    interval: 1.9,
    potential: [0, 23, 0, 0, 0],
    trust: [0, 65, 0, 0, 0],
    moduleX: [120, 45, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
  {
    name: "ムリナール",
    rarity: 6,
    class: "前衛",
    hp: 3906,
    atk: 355,
    def: 502,
    res: 15,
    block: 3,
    interval: 1.2,
    potential: [0, 25, 0, 0, 0],
    trust: [360, 30, 0, 0, 0],
    moduleX: [0, 0, 0, 0, 0],
    moduleY: [0, 0, 0, 0, 0],
  },
];
